import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@/assets/css/sweetalert-custom.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './registerServiceWorker'

createApp(App).use(router).mount('#app')
